webpackJsonp([114276838955818,60335399758886],{

/***/ 97:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(204);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(97);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(284);
	var isArguments = __webpack_require__(283);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(425);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(282);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(404);
	
	var _HelmetConstants = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(291);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(440);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\theight: 46px;\n\twidth: 46px;\n\tbackground: ', ';\n\t', '\n\ttransition: 0.2s;\n\t', '\n  display: none;\n  padding-right: 5px;\n  position: relative;\n  overflow: hidden;\n  @media (max-width: 625px) {\n    display: inline-block;\n  }\n'], ['\n\theight: 46px;\n\twidth: 46px;\n\tbackground: ', ';\n\t', '\n\ttransition: 0.2s;\n\t', '\n  display: none;\n  padding-right: 5px;\n  position: relative;\n  overflow: hidden;\n  @media (max-width: 625px) {\n    display: inline-block;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 25px;\n  height: 2px;\n  margin: calc(50% - 2px) 11px;\n  background: white;\n  display: inline-block;\n  transition: 0.3s;\n  top: 0;\n  left: 0;\n  position: absolute;\n'], ['\n  width: 25px;\n  height: 2px;\n  margin: calc(50% - 2px) 11px;\n  background: white;\n  display: inline-block;\n  transition: 0.3s;\n  top: 0;\n  left: 0;\n  position: absolute;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  top: ', ';\n  transform: ', ';\n'], ['\n  top: ', ';\n  transform: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n'], ['\n  background: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _NavModal = __webpack_require__(120);
	
	var _NavModal2 = _interopRequireDefault(_NavModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Burger = function (_React$Component) {
	  _inherits(Burger, _React$Component);
	
	  function Burger() {
	    _classCallCheck(this, Burger);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Burger.prototype.render = function render() {
	    return _react2.default.createElement(
	      MenuButton,
	      { expanded: this.props.visible, onClick: this.props.onClick },
	      _react2.default.createElement(TopLine, { expanded: this.props.visible }),
	      _react2.default.createElement(MiddleLine, { expanded: this.props.visible }),
	      _react2.default.createElement(BottomLine, { expanded: this.props.visible })
	    );
	  };
	
	  return Burger;
	}(_react2.default.Component);
	
	exports.default = Burger;
	
	
	var MenuButton = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.expanded === true && 'mediumpurple' || '#333';
	}, '' /* margin: auto; */, '' /* box-sizing: border-box; */);
	
	var Line = _styledComponents2.default.div(_templateObject2);
	
	var TopLine = Line.extend(_templateObject3, function (props) {
	  return props.expanded === true && '0px' || '-7px';
	}, function (props) {
	  return props.expanded === true && 'rotate(45deg)' || '';
	});
	
	var MiddleLine = Line.extend(_templateObject4, function (props) {
	  return props.expanded === true && 'none' || 'white';
	});
	
	var BottomLine = Line.extend(_templateObject3, function (props) {
	  return props.expanded === true && '0px' || '7px';
	}, function (props) {
	  return props.expanded === true && 'rotate(-45deg)' || '';
	});
	module.exports = exports['default'];

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: #333;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  min-height: 100px;\n  padding: 10px 0;\n  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n\n'], ['\n  background: #333;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  min-height: 100px;\n  padding: 10px 0;\n  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  padding: 10px 10px;\n  flex: 1 1 auto;\n'], ['\n  margin: 0 auto;\n  padding: 10px 10px;\n  flex: 1 1 auto;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  padding: 10px 10px;\n  text-align: center;\n  margin: auto;\n'], ['\n  list-style: none;\n  padding: 10px 10px;\n  text-align: center;\n  margin: auto;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 2rem;\n  display: block;\n  color: #888;\n  opacity: 0.7;\n  text-decoration: none;\n  font-weight: 300;\n  padding: 0px 10px;\n\n  &:first-of-type {\n    font-size: 1rem;\n  }\n'], ['\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 2rem;\n  display: block;\n  color: #888;\n  opacity: 0.7;\n  text-decoration: none;\n  font-weight: 300;\n  padding: 0px 10px;\n\n  &:first-of-type {\n    font-size: 1rem;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  color: #888;\n  opacity: 0.5;\n  font-weight: 400;\n  ', '\n'], ['\n  color: #888;\n  opacity: 0.5;\n  font-weight: 400;\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        ContainerNav,
	        null,
	        _react2.default.createElement(
	          NavItem,
	          null,
	          '\xA9 2019 - Amy E. Zimmerman'
	        ),
	        this.props.location.pathname === '/' && _react2.default.createElement(
	          NavItem,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            'Lead photo by '
	          ),
	          _react2.default.createElement(
	            FooterLink,
	            {
	              href: 'https://unsplash.com/photos/ewtdGmhY1vI?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText',
	              target: '_blank' },
	            'Aaron Bean'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ' on '
	          ),
	          _react2.default.createElement(
	            FooterLink,
	            {
	              href: 'https://unsplash.com/search/photos/chicago?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText',
	              target: '_blank' },
	            'Unsplash'
	          )
	        ),
	        _react2.default.createElement(
	          NavItem,
	          null,
	          _react2.default.createElement(
	            'span',
	            null,
	            '</>',
	            ' with love by '
	          ),
	          _react2.default.createElement(
	            FooterLink,
	            {
	              href: 'http://andrewzim.com',
	              target: '_blank' },
	            'AndrewZim'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ' using '
	          ),
	          _react2.default.createElement(
	            FooterLink,
	            {
	              href: 'https://gatsbyjs.org',
	              target: '_blank' },
	            'Gatsby.js'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ', '
	          ),
	          _react2.default.createElement(
	            FooterLink,
	            {
	              href: 'https://contentful.com',
	              target: '_blank' },
	            'Contentful'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ', and '
	          ),
	          _react2.default.createElement(
	            FooterLink,
	            {
	              href: 'https://netlify.com',
	              target: '_blank' },
	            'Netlify'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            '.'
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var TitleContainer = _styledComponents2.default.div(_templateObject2);
	var ContainerNav = _styledComponents2.default.div(_templateObject3);
	
	var NavItem = _styledComponents2.default.h1(_templateObject4);
	
	var FooterLink = _styledComponents2.default.a(_templateObject5, '' /* text-decoration: none; */);
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: #333;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n'], ['\n  background: #333;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  padding: 0px 10px;\n  flex: 1 1 auto;\n'], ['\n  margin: 0 auto;\n  padding: 0px 10px;\n  flex: 1 1 auto;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  list-style: none;\n  padding: 0px 10px;\n\n  @media (max-width: 625px) {\n    display: none;\n  }\n'], ['\n  list-style: none;\n  padding: 0px 10px;\n\n  @media (max-width: 625px) {\n    display: none;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 10px 20px;\n  background: #333;\n  color: white;\n  display: none;\n\n  @media (max-width: 625px) {\n    display: inline-block;\n  }\n'], ['\n  padding: 10px 20px;\n  background: #333;\n  color: white;\n  display: none;\n\n  @media (max-width: 625px) {\n    display: inline-block;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  font-size: 1rem;\n  line-height: 2rem;\n  display: inline-block;\n  color: ', ';\n  text-decoration: none;\n  font-weight: 300;\n  padding: 0px 10px;\n  ', '\n  border-top: 5px solid transparent;\n  border-bottom: ', ';\n  &:hover {\n    opacity: 0.9;\n    border-bottom: 5px solid #eee;\n  }\n'], ['\n  margin: 0;\n  font-size: 1rem;\n  line-height: 2rem;\n  display: inline-block;\n  color: ', ';\n  text-decoration: none;\n  font-weight: 300;\n  padding: 0px 10px;\n  ', '\n  border-top: 5px solid transparent;\n  border-bottom: ', ';\n  &:hover {\n    opacity: 0.9;\n    border-bottom: 5px solid #eee;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _NavModal = __webpack_require__(120);
	
	var _NavModal2 = _interopRequireDefault(_NavModal);
	
	var _Burger = __webpack_require__(193);
	
	var _Burger2 = _interopRequireDefault(_Burger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      modalIsVisible: false
	    };
	    _this.handleModalButtonClick = _this.handleModalButtonClick.bind(_this);
	    return _this;
	  }
	
	  Header.prototype.handleModalButtonClick = function handleModalButtonClick() {
	    var toggle = !this.state.modalIsVisible;
	    this.setState({
	      modalIsVisible: toggle
	    });
	  };
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        HeaderContainer,
	        null,
	        _react2.default.createElement(
	          TitleContainer,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement(
	              NavItem,
	              null,
	              'Amy E. Zimmerman'
	            )
	          )
	        ),
	        _react2.default.createElement(_Burger2.default, { onClick: this.handleModalButtonClick, visible: this.state.modalIsVisible }),
	        _react2.default.createElement(
	          NavContainer,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/research/' },
	            this.props.location.pathname === '/research/' && _react2.default.createElement(
	              NavItem,
	              { selected: true },
	              'Research'
	            ) || _react2.default.createElement(
	              NavItem,
	              null,
	              'Research'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/publications/' },
	            this.props.location.pathname === '/publications/' && _react2.default.createElement(
	              NavItem,
	              { selected: true },
	              'Publications'
	            ) || _react2.default.createElement(
	              NavItem,
	              null,
	              'Publications'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/people/' },
	            this.props.location.pathname === '/people/' && _react2.default.createElement(
	              NavItem,
	              { selected: true },
	              'People'
	            ) || _react2.default.createElement(
	              NavItem,
	              null,
	              'People'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/teaching/' },
	            this.props.location.pathname === '/teaching/' && _react2.default.createElement(
	              NavItem,
	              { selected: true },
	              'Teaching'
	            ) || _react2.default.createElement(
	              NavItem,
	              null,
	              'Teaching'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_NavModal2.default, {
	        height: this.state.modalIsVisible ? '310px' : '0px',
	        location: this.props.location, onClick: this.handleModalButtonClick })
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	
	
	var HeaderContainer = _styledComponents2.default.div(_templateObject);
	
	var TitleContainer = _styledComponents2.default.div(_templateObject2);
	var NavContainer = _styledComponents2.default.div(_templateObject3);
	
	var ModalButton = _styledComponents2.default.button(_templateObject4);
	
	var NavItem = _styledComponents2.default.h1(_templateObject5, function (props) {
	  return props.selected && 'mediumpurple' || 'white';
	}, '' /* background: ${props =>
	      (props.selected && 'mediumpurple')
	      || 'transparent'
	      }; */, function (props) {
	  return props.selected && '5px solid mediumpurple' || '5px solid transparent';
	});
	//
	// const NavMenu = styled.div`
	//   z-index: 100;
	//   position: fixed;
	//   top: 0;
	//   left: 0;
	//   bottom: 0;
	//   width: 100%;
	//   height: 100%;
	//   display: flex;
	//   background: #333;
	//   opacity: 0.9;
	// `;
	
	module.exports = exports['default'];

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  z-index: 100;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: #333;\n  overflow: hidden;\n  height: ', ';\n  transition: height 0.3s ease-out;\n\n  @media (min-width: 625px) {\n    height: 0;\n  }\n'], ['\n  width: 100%;\n  z-index: 100;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: #333;\n  overflow: hidden;\n  height: ', ';\n  transition: height 0.3s ease-out;\n\n  @media (min-width: 625px) {\n    height: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  ', '\n  text-align: ', ';\n  border-top: 1px solid #444;\n\n'], ['\n  width: 100%;\n  ', '\n  text-align: ', ';\n  border-top: 1px solid #444;\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  height: 50px;\n'], ['\n  width: 50px;\n  height: 50px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  width: 100%;\n  font-size: 1rem;\n  line-height: 2rem;\n  display: inline-block;\n  color: white;\n  background: ', ';\n  text-decoration: none;\n  font-weight: 300;\n  padding: 10px;\n  ', '\n  border-top: 5px solid transparent;\n  &:hover {\n    background: ', ';\n    opacity: 0.9;\n    ', '\n  }\n'], ['\n  margin: 0;\n  width: 100%;\n  font-size: 1rem;\n  line-height: 2rem;\n  display: inline-block;\n  color: white;\n  background: ', ';\n  text-decoration: none;\n  font-weight: 300;\n  padding: 10px;\n  ', '\n  border-top: 5px solid transparent;\n  &:hover {\n    background: ', ';\n    opacity: 0.9;\n    ', '\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavModal = function (_React$Component) {
	  _inherits(NavModal, _React$Component);
	
	  function NavModal() {
	    _classCallCheck(this, NavModal);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NavModal.prototype.render = function render() {
	    return _react2.default.createElement(
	      NavMenuContainer,
	      { height: this.props.height },
	      _react2.default.createElement(
	        MenuItem,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          this.props.location.pathname === '/' && _react2.default.createElement(
	            NavItem,
	            { selected: true },
	            'Home'
	          ) || _react2.default.createElement(
	            NavItem,
	            null,
	            'Home'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        MenuItem,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/people/' },
	          this.props.location.pathname === '/people/' && _react2.default.createElement(
	            NavItem,
	            { selected: true },
	            'People'
	          ) || _react2.default.createElement(
	            NavItem,
	            null,
	            'People'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        MenuItem,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/publications/' },
	          this.props.location.pathname === '/publications/' && _react2.default.createElement(
	            NavItem,
	            { selected: true },
	            'Publications'
	          ) || _react2.default.createElement(
	            NavItem,
	            null,
	            'Publications'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        MenuItem,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/research/' },
	          this.props.location.pathname === '/research/' && _react2.default.createElement(
	            NavItem,
	            { selected: true },
	            'Research'
	          ) || _react2.default.createElement(
	            NavItem,
	            null,
	            'Research'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        MenuItem,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/teaching/' },
	          this.props.location.pathname === '/teaching/' && _react2.default.createElement(
	            NavItem,
	            { selected: true },
	            'Teaching'
	          ) || _react2.default.createElement(
	            NavItem,
	            null,
	            'Teaching'
	          )
	        )
	      )
	    );
	  };
	
	  return NavModal;
	}(_react2.default.Component);
	
	exports.default = NavModal;
	
	// const HeaderContainer = styled.div`
	//   background: #333;
	//   display: flex;
	//   flex-direction: row;
	//   justify-content: space-between;
	//   font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	//
	// `;
	//
	// const TitleContainer = styled.div`
	//   margin: 0 auto;
	//   padding: 0px 10px;
	//   flex: 1 1 auto;
	// `;
	// const NavContainer = styled.div`
	//   list-style: none;
	//   padding: 0px 10px;
	// `;
	
	var NavMenuContainer = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.height || '0';
	});
	
	var MenuItem = _styledComponents2.default.div(_templateObject2, '' /* padding: 20px; */, function (props) {
	  return props.right && 'right' || 'center';
	});
	
	var CloseButton = _styledComponents2.default.button(_templateObject3);
	
	var NavItem = _styledComponents2.default.h1(_templateObject4, function (props) {
	  return props.selected && 'mediumpurple' || '';
	}, '' /* background: ${props =>
	      (props.selected && 'mediumpurple')
	      || 'transparent'
	      }; */, function (props) {
	  return props.selected && 'mediumpurple' || '#444';
	}, '' /* border-bottom: 5px solid #eee; */);
	module.exports = exports['default'];

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(403);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _favicon = __webpack_require__(452);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	var _Header = __webpack_require__(196);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(195);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: 'Amy E. Zimmerman'
	        // meta={[
	        //   { name: 'description', content: 'Sample' },
	        //   { name: 'keywords', content: 'sample, something' },
	        // ]}
	      },
	      _react2.default.createElement('link', { rel: 'shortcut icon', href: _favicon2.default, type: 'image/x-icon' }),
	      _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Lato:300,400', rel: 'stylesheet' }),
	      _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Open+Sans:300,400', rel: 'stylesheet' })
	    ),
	    _react2.default.createElement(_Header2.default, { location: location }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto',
	          // maxWidth: 960,
	          // padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        }
	      },
	      children(),
	      _react2.default.createElement(_Footer2.default, { location: location })
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-df358c4e05752b35c56d.js